import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import CloseButton from './CloseButton'
import SwitchLocaleMobileMenu from './Locale/SwitchLocaleMobileMenu'
import { PERMISSIONMENU } from './MenuComponents/getMenu'
import NationalCards from './NationalCards'


const MobileMenu = ({data = {}, isOpen, role, handleMenuClose, onOpenCountrySelect, onOpenSigin, isLogged, user, openClaim, openSettings, logOut }) => {
  //MenuList - динамический компонет, содержит разные ссылки в зависимости от роли
  const MenuList = PERMISSIONMENU[role].mobile;
  return(
    <div className={classNames('Menu', { 'Menu_show': isOpen })}>
      <div className='Menu__body'>
        <CloseButton className='Menu__close' onClick={handleMenuClose} />
        <MenuList
          data={data}
          openClaim={openClaim}
          handleMenuClose={handleMenuClose}
        />
        <NationalCards classname='orange menu' />
        {
          isLogged ? <div>
            <a href='/profile' onClick={handleMenuClose} className='Menu__enter Menu__link Link Head Link_light'>{user.name}</a>
            <a onClick={handleMenuClose}>
              <SwitchLocaleMobileMenu onClick={onOpenCountrySelect} />
            </a>
            <div className='Menu__actions'>
              {role === 'user' && 
                <button className='Link Link_light Menu__actions-item' onClick={openSettings}>
                  <FormattedMessage id='mobile_menu.settings' />
                </button>
              }
              <button className='Link Link_light Menu__actions-item' onClick={logOut}>
                <FormattedMessage id='mobile_menu.logout' />
              </button>
            </div>
          </div>
            : <div>
              <a className='Menu__enter' onClick={handleMenuClose}>
                <SwitchLocaleMobileMenu onClick={onOpenCountrySelect} />
              </a>
              <button className='Menu__link Link Head Link_single Link_light' onClick={onOpenSigin} type='button'>
                <FormattedMessage id='mobile_menu.login' />
              </button>
            </div>
        }
      </div>
    </div>
)}
const mapStateToProps = ({ contacts }) => ({ ...contacts });

export default compose(
  connect(mapStateToProps),
)(MobileMenu)




// WEBPACK FOOTER //
// ./src/components/MobileMenu.jsx